import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'wl-subscription-settings',
    template: `
        <div class="gutter-padding">
            <h2>{{ 'GLOBAL.SETTINGS.ACCOUNT.MANAGE_SUBSCRIPTION' | translate }}</h2>
            <wl-manage-subscription></wl-manage-subscription>
        </div>
    `
})
export class SubscriptionSettingsPage {}
